function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.68-89.68a39.68 29.361 0 0 1-39.519 29.36 39.68 29.361 0 0 1-39.838-29.124l39.678-.237z",
    style: {
      fill: "#da0d0d",
      fillOpacity: 0,
      stroke: "#fefefe",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 32.5,
    r: 22.182,
    style: {
      fill: "#da0d0d",
      fillOpacity: 0,
      stroke: "#fefefe",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.2bfd52352b3465090928faebf7d6cf29.svg";
export { ForwardRef as ReactComponent };